// Components
// Types
import useTranslation from '@/utils/hooks/translation/useTranslation';
// Hooks
import useActiveGroup from '@/utils/hooks/user/useActiveGroup';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

import useToggle from '@/utils/hooks/utils/useToggle';

import { ModalUpsell } from '@/components/composite/Modals/ModalUpsell';
import { PageHeaderRecap } from '@/components/layouts/LayoutPlatform/components/PageHeaderRecap';

export const HeaderConversations = () => {
    const { activeGroup } = useActiveGroup();
    const { activeSocialProfile } = useActiveSocialProfile();
    const { t: tCommons } = useTranslation('commons');
    const { isOpen, toggle } = useToggle();

    const getPageTitle = () => {
        if (!activeSocialProfile?.id && activeGroup) {
            return tCommons('menu.group_conversations');
        }

        return tCommons('menu.conversations');
    };

    return (
        <>
            <PageHeaderRecap title={getPageTitle()} />
            <ModalUpsell
                heading={tCommons('upsell_modal.mentions.heading')}
                description={tCommons('upsell_modal.mentions.description')}
                benefits={[
                    { text: tCommons('upsell_modal.mentions.benefit1'), icon: 'check' },
                    { text: tCommons('upsell_modal.mentions.benefit2'), icon: 'check' },
                    { text: tCommons('upsell_modal.mentions.benefit3'), icon: 'check' },
                    { text: tCommons('upsell_modal.mentions.benefit4'), icon: 'plus' }
                ]}
                illustrationPath="/images/modals/modalUpsell/mention.png"
                dismiss={toggle}
                isOpen={isOpen}
            />
        </>
    );
};
